import { render, staticRenderFns } from "./Concox.vue?vue&type=template&id=2b6b179f"
import script from "./Concox.vue?vue&type=script&lang=js"
export * from "./Concox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports